// Атрибуция генерации к источнику: popular_category-карточка ИЛИ style preset.
//
// Карточка ≡ конкретный инструмент (модель + пресет промпта). «Использование
// карточки» = генерация ЭТИМ инструментом, поэтому тег карточки держится на ВСЕХ
// генерациях, пока модель = модели карточки (доработки / ре-роллы / правки промпта
// → засчитываются в «Обращений»), и СНИМАЕТСЯ при смене модели (юзер ушёл с
// инструмента карточки → это уже другая нейронка), при новом клике по карточке
// (перезапись) или уходе со страницы генерации (clearActiveSourceCard).
//
// Модель карточки фиксируется на ПЕРВОЙ генерации — не нужно знать её на клике.
// Тег НЕ зависит от текста промпта (устойчив к редактированию). Различение
// «доработка у нас» vs «ушёл в другую нейронку» — по детерминированному событию
// (смена модели), без размытого сравнения промптов.
//
// Style preset — ТА ЖЕ липкая семантика, что у карточки (раньше был one-shot):
// тренды открываются как инструменты, повторные генерации («Создать» ещё раз,
// доработки) должны нести source_style_id — на нём и статистика, и MONEY-PATH
// floor-кламп цены (style_presets.price_override). Смена модели снимает контекст.

let card: { id: string; model: string | null } | null = null
let style: { id: string; model: string | null } | null = null

/** Клик по карточке: ставим контекст. Модель привяжется на первой генерации. */
export function setPendingSourceCard(id: string | null): void {
	card = id ? { id, model: null } : null
}

/**
 * Вызывается клиентом на КАЖДОМ запросе генерации (см. ApiClient.request):
 *   - первая генерация → фиксируем модель карточки, возвращаем id;
 *   - та же модель → доработка / ре-ролл, возвращаем id (контекст жив);
 *   - другая модель → юзер ушёл с инструмента карточки → снимаем контекст, null.
 */
export function consumeSourceCardForModel(model: string | null): string | null {
	if (!card) return null
	const m = model || null
	if (card.model === null) {
		card.model = m
		return card.id
	}
	if (card.model === m) {
		return card.id
	}
	card = null
	return null
}

/** Сброс контекста карточки (уход со страницы генерации / явный reset). */
export function clearActiveSourceCard(): void {
	card = null
}

/** Клик по стилю/тренду: ставим контекст (модель привяжется на первой генерации). */
export function setPendingSourceStyle(id: string | null): void {
	style = id ? { id, model: null } : null
}

/**
 * Атрибуция стиля на КАЖДОМ запросе генерации — зеркало
 * consumeSourceCardForModel: первая генерация фиксирует модель, совпадение
 * модели держит контекст (ре-роллы/доработки), смена модели снимает.
 */
export function consumeSourceStyleForModel(model: string | null): string | null {
	if (!style) return null
	const m = model || null
	if (style.model === null) {
		style.model = m
		return style.id
	}
	if (style.model === m) {
		return style.id
	}
	style = null
	return null
}

/** Сброс контекста стиля (открепление пина / уход со страницы). */
export function clearActiveSourceStyle(): void {
	style = null
}
